import React from 'react';
import PropTypes from 'prop-types';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';
import IOSLayoutSettingsForm from '../../../components/siteadmin/IOSLayoutSettingsForm';
import Loader from '../../../components/Loader';
import getLayoutSettings from '../../../actions/siteadmin/ConfigSettings/getLayoutSettings.graphql';
import s from './IOSLayoutSettings.css';
import { withQuery } from '../../../hoc/withGraphql';

const IOSLayoutSettings = (props) => {

  const { data: { loading, getLayoutSettings } } = props;
  let settingsCollection = {};
  !loading && getLayoutSettings?.results?.map((item, key) => {
    settingsCollection[item?.name] = item?.themeType;
    if (item?.orderType) settingsCollection[item?.name + 'Order'] = item?.orderType;
  });
  if (loading) {
    return <Loader type={"text"} />;
  } else {
    return settingsCollection && !loading && <IOSLayoutSettingsForm initialValues={settingsCollection} />
  }
}

IOSLayoutSettings.propTypes = {
  title: PropTypes.string.isRequired,
  data: PropTypes.shape({
    loading: PropTypes.bool,
    getLayoutSettings: PropTypes.array,
  })
};

IOSLayoutSettings.defaultProps = {
  data: {
    loading: true
  }
};

export default compose(
  withStyles(s),
  withQuery(getLayoutSettings,
    {
      options: (props) => ({
        fetchPolicy: 'network-only',
        ssr: false
      })
    }
  ),
)(IOSLayoutSettings);
